package com.example.readingnotes.presentation.sales

import com.example.readingnotes.domain.model.SalesDashboard

/**
 * Sales period filter options
 */
enum class SalesPeriod {
    ALL,
    THIS_MONTH,
    THIS_WEEK,
    TODAY,
}

/**
 * UI state for Sales Dashboard screen
 */
data class SalesDashboardState(
    val isLoading: Boolean = false,
    val dashboard: SalesDashboard? = null,
    val errorMessage: String? = null,
    val selectedPeriod: SalesPeriod = SalesPeriod.ALL,
    val isRefreshing: Boolean = false,
)
